// ACC-440: dragging a card changes its status via UpdateTicket, which the
// Forecast gateway (ACC-468) gates on TICKETS_MANAGE. So board edits are gated
// on that one permission — there is no per-ticket ownership path (that legacy
// role rule would now hit a gateway FORBIDDEN and silently revert). Users
// without TICKETS_MANAGE get a read-only board. UX gate only; the gateway is
// the trust boundary.
export function canDragTicket(canManage: boolean): boolean {
	return canManage;
}
